import React from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface Props {
  company: {
    presentationName: string
  }
  onAnswer: (isSharing: boolean) => void
  onHide: () => void
}

const ShareCompassReportModal: React.FC<Props> = ({
  company,
  onAnswer,
  onHide,
}) => {
  return (
    <Dialog open onHide={onHide}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Sharing your Compass insights</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <p className="mb-4">
            Are you happy for your Compass snapshot to be shared with{' '}
            <b>{company?.presentationName}</b> before you speak with them?
          </p>

          <p className="mb-4">
            This will help them prepare for your initial conversation. You can
            revoke access to this at any time from the <b>Sharing</b> tab.
          </p>
        </DialogBody>

        <DialogFooter>
          <Button variant="outline-secondary" onClick={() => onAnswer(false)}>
            Don't share
          </Button>

          <Button variant="success" onClick={() => onAnswer(true)}>
            Share
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ShareCompassReportModal
